import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import './driver_management.css'

export const DriverManagement = () => {
  const storagePage = localStorage.getItem('driver_page') || '/schedule'

  return <Outlet />
}
